type CelebrationSound = "blockGenerated" | "achievementUnlocked";

const CELEBRATION_SOUND_PATHS = {
  blockGenerated: "/sounds/success.mp3",
  achievementUnlocked: "/sounds/quest-completed.mp3",
} as const satisfies Record<CelebrationSound, string>;

type PlayCelebrationSoundOptions = {
  hasUserInteraction: boolean;
  muted: boolean;
  reducedMotion: boolean;
  sound: CelebrationSound;
  volume: number;
};

function clampVolume(volume: number) {
  return Math.min(1, Math.max(0, volume));
}

export function playCelebrationSound({
  hasUserInteraction,
  muted,
  reducedMotion,
  sound,
  volume,
}: PlayCelebrationSoundOptions) {
  if (muted || reducedMotion || !hasUserInteraction) return;
  if (typeof Audio === "undefined") return;

  try {
    const audio = new Audio(CELEBRATION_SOUND_PATHS[sound]);
    audio.preload = "auto";
    audio.volume = clampVolume(volume);
    const playPromise = audio.play();
    if (playPromise && typeof playPromise.catch === "function") {
      void playPromise.catch(() => undefined);
    }
  } catch {
    // Audio is progressive enhancement. Browser policy or decode failures
    // should never make a celebration fail.
  }
}
